import React from 'react';
import { useMantineTheme, Group, ActionIcon } from '@mantine/core';
import { ArrowIcon } from '../ArrowIcon.js';
import { CalendarLabel } from '../CalendarLabel/CalendarLabel.js';
import { sizes } from '../../Month/Day/Day.styles.js';
var iconSizes = {
  xs: 10,
  sm: 12,
  md: 14,
  lg: 18,
  xl: 20
};
function CalendarHeader(_ref) {
  var size = _ref.size,
    nextMonthLabel = _ref.nextMonthLabel,
    previousMonthLabel = _ref.previousMonthLabel,
    previousMonthDisabled = _ref.previousMonthDisabled,
    nextMonthDisabled = _ref.nextMonthDisabled,
    onPreviousMonth = _ref.onPreviousMonth,
    onNextMonth = _ref.onNextMonth,
    classNames = _ref.classNames,
    styles = _ref.styles,
    locale = _ref.locale,
    withSelect = _ref.withSelect,
    yearsRange = _ref.yearsRange,
    month = _ref.month,
    setMonth = _ref.setMonth,
    labelFormat = _ref.labelFormat,
    __staticSelector = _ref.__staticSelector,
    monthLabel = _ref.monthLabel,
    yearLabel = _ref.yearLabel,
    _ref$preventFocus = _ref.preventFocus,
    preventFocus = _ref$preventFocus === void 0 ? false : _ref$preventFocus,
    hiddenMonth = _ref.hiddenMonth;
  var theme = useMantineTheme();
  var iconSize = theme.fn.size({
    size: size,
    sizes: iconSizes
  });
  var iconButtonSize = theme.fn.size({
    size: size,
    sizes: sizes
  });
  var controlStyles = {
    "&:disabled": {
      backgroundColor: "transparent",
      borderColor: "transparent",
      opacity: 0.4
    }
  };
  return /* @__PURE__ */React.createElement(Group, {
    position: "apart",
    noWrap: true,
    style: {
      marginBottom: theme.spacing.xs / 2
    }
  }, /* @__PURE__ */React.createElement(ActionIcon, {
    "aria-label": previousMonthLabel,
    onClick: onPreviousMonth,
    onMouseDown: function onMouseDown(event) {
      return preventFocus && event.preventDefault();
    },
    tabIndex: preventFocus ? -1 : 0,
    disabled: previousMonthDisabled,
    size: iconButtonSize,
    style: {
      visibility: ["prev", "both"].includes(hiddenMonth) ? "hidden" : "visible"
    },
    "data-mantine-stop-propagation": true,
    sx: controlStyles
  }, /* @__PURE__ */React.createElement(ArrowIcon, {
    direction: "left",
    width: iconSize,
    height: iconSize
  })), /* @__PURE__ */React.createElement(CalendarLabel, {
    locale: locale,
    classNames: classNames,
    styles: styles,
    withSelect: withSelect,
    yearsRange: yearsRange,
    value: month,
    onChange: setMonth,
    labelFormat: labelFormat,
    size: size,
    __staticSelector: __staticSelector,
    monthLabel: monthLabel,
    yearLabel: yearLabel,
    preventFocus: preventFocus
  }), /* @__PURE__ */React.createElement(ActionIcon, {
    "aria-label": nextMonthLabel,
    onClick: onNextMonth,
    tabIndex: preventFocus ? -1 : 0,
    onMouseDown: function onMouseDown(event) {
      return preventFocus && event.preventDefault();
    },
    disabled: nextMonthDisabled,
    size: iconButtonSize,
    style: {
      visibility: ["next", "both"].includes(hiddenMonth) ? "hidden" : "visible"
    },
    "data-mantine-stop-propagation": true,
    sx: controlStyles
  }, /* @__PURE__ */React.createElement(ArrowIcon, {
    direction: "right",
    width: iconSize,
    height: iconSize
  })));
}
CalendarHeader.displayName = "@mantine/dates/CalendarHeader";
export { CalendarHeader };